import { render, staticRenderFns } from "./staticNotice.vue?vue&type=template&id=f6a7f9fc&scoped=true&"
import script from "./staticNotice.vue?vue&type=script&lang=js&"
export * from "./staticNotice.vue?vue&type=script&lang=js&"
import style0 from "./staticNotice.vue?vue&type=style&index=0&id=f6a7f9fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a7f9fc",
  null
  
)

export default component.exports